const AnimalHusbandrydata = [
    {
        id : "1",
        schemeName: "Rashtriya Gokul Mission (RGM)",
        discription:"The Rashtriya Gokul Mission (RGM) is being implemented for development and conservation of indigenous bovine breeds since December 2014. The scheme is important in enhancing milk production and productivity of bovines to meet growing demand of milk and making dairying more remunerative to the rural farmers of the country. ",
        launchDate: "December 2014",
        AnualFund: "12345"

    },
   {id : "2",
    schemeName: "National Livestock Mission (NLM)",
    discription:"The focus of the scheme is on entrepreneurship development and breed improvement in poultry, sheep, goat and piggery including feed and fodder development.",
    launchDate: " year 2014-15",
    AnualFund: "12345"},
   

    {id : "3",
    schemeName: "LiveStock  Health & Disease Control (LH & DC)",
    discription:"The overall aim of the Livestock Health & Disease Control scheme is to improve the animal health sector by way of implementation of prophylactic vaccination programmes against various diseases of livestock and poultry, capacity building, disease surveillance and strengthening of veterinary infrastructure.",
    launchDate: "year 2021-22",
    AnualFund: "12345"},
   
    {
    id : "4",
        schemeName: "National Programme for dairy Development (NPDD) ",
        discription:"The NPDD scheme aims to enhance quality of milk and milk products and increase share of organized milk procurement. ",
        launchDate: "February",
        AnualFund: "12345"
    },
   { id : "5",
    schemeName: "LiveStock Census and Integrated Sample Survey (LC & ISS)",
    discription:"The Animal Husbandry Statistics (AHS) Division of Department of Animal Husbandry & Dairying (DAHD) is entrusted with the generation of Animal Husbandry Statistics through the Centrally Sponsored Scheme “Livestock Census and Integrated Sample Survey”under the development programmer category with two components",
    launchDate: "write", 
     AnualFund: "12345"},
   

 {   id : "6",
    schemeName: "National Animal Disease Control Programme (NADCP)",
    discription:"National Animal Disease Control Programme (NADCP) is a flagship scheme launched by Hon'ble Prime Minister in September, 2019 for control of Foot & Mouth Disease and Brucellosis by vaccinating 100% cattle, buffalo, sheep, goat and pig population for FMD and 100% bovine female calves of 4-8 months of age for brucellosis with the total outlay of Rs.13, 343.00 crore for five years (2019-20 to 2023-24).",
    launchDate: "September 2019",
    AnualFund: "12345"
},
{   id : "7",
schemeName: "Dairy Infrastructure Development Fund (DIDF).",
discription:"Consequent to the Union Budget 2017-18 announcement, Dairy Processing & Infrastructure Development Fund has been set up with a corpus of Rs. 8,004 crore with National Bank for Agriculture and Rural Development (NABARD).",
launchDate: "December 2017",
AnualFund: "12345"},


{   id : "8",
schemeName: "Animal Husbandry Infrastructure development Fund (AHIDF)",
discription:"The Animal Husbandry Infrastructure Development (AHIDF) has been approved for incentivizing investments by individual entrepreneurs, private companies, MSME, Farmers Producers Organizations (FPOs) and Section 8 companies to establish (i) the dairy processing and value addition infrastructure, (ii) meat processing and value addition infrastructure and (iii) Animal Feed Plant.",
launchDate: "June 2020",
AnualFund: "12345"},


{   id : "9",
schemeName: "Supporting Dairy Cooperatives and Farmer Producer organizations (SDCFPO)",
discription:"A Scheme named “Supporting Dairy Cooperatives and Farmer Producer Organizations engaged in dairy activities” was approved to provide working capital loan to State Cooperatives and Federations. An amount of Rs. 303 crore has been released to National Dairy Development Board till December 2021 for implementation of the scheme",
launchDate: " Year 2017-18",
AnualFund: "12345"},

]

export default AnimalHusbandrydata;